import { cloneDeep, has } from 'lodash';
import {
  updateLineItemsOnUpdateHelper, updateLineItemsOnCreateHelper, updateOnCreateExceptionHelper,
  getNewLineItem, addLineItemErrorHelper, deleteLineItemHelper, addLineItemEventsHelper,
} from '../utils/lineItemUtils';

const initialState = {
  loading: false,
  items: [],
};

const getLaborSheet = (laborSheets, id) =>
  laborSheets.find(ls => ls.id === id);

const addBlankLineItemToPhase = (state, type) => {
  const stateLineItems = cloneDeep(state.data);
  if (type === 'contractorLineItems' && stateLineItems.length > 0) {
    stateLineItems.forEach(laborSheet =>
      laborSheet.line_items.push(getNewLineItem()),
    );
  } else if (type !== 'contractorLineItems') {
    stateLineItems.push(getNewLineItem());
  }
  return stateLineItems;
};

const addBlankLevelerToPhase = (state, type) => {
  const stateLevelerItems = cloneDeep(state);
  if (type === 'levelers' && stateLevelerItems.length > 0) {
    stateLevelerItems.forEach(item => item.data.push(getNewLineItem()));
  }
  stateLevelerItems.data.push(getNewLineItem());
  return stateLevelerItems;
};

const getLineItemsToUpdate = (stateLineItems, payload) => {
  if (payload.type === 'contractorLineItems') {
    const laborSheet = getLaborSheet(stateLineItems, payload.line_item.labor_sheet_id);
    return laborSheet.line_items;
  }
  return stateLineItems;
};

const updateStateLineItemsOnCreate = (state, payload, listName) => {
  const stateLineItems = cloneDeep(state.items);
  const lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  if (payload.type === 'exception') {
    updateOnCreateExceptionHelper(lineItemsToUpdate, payload, listName);
  } else {
    updateLineItemsOnCreateHelper(lineItemsToUpdate, payload);
  }
  return stateLineItems;
};

const removeStateLineItemOnDelete = (state, payload) => {
  const stateLineItems = cloneDeep(state.items);
  const lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  deleteLineItemHelper(lineItemsToUpdate, payload.line_item.id);
  return stateLineItems;
};

const updateStateLineItemsOnUpdate = (state, payload) => {
  const stateLineItems = cloneDeep(state.items);
  const lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  updateLineItemsOnUpdateHelper(lineItemsToUpdate, payload);
  return stateLineItems;
};

const addLineItemError = (state, payload) => {
  const stateLineItems = cloneDeep(state.items);
  const lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  addLineItemErrorHelper(lineItemsToUpdate, payload);
  return stateLineItems;
};

const addLineItemEvent = (state, payload) => {
  const stateLineItems = cloneDeep(state.items);
  const lineItemsToUpdate = getLineItemsToUpdate(stateLineItems, payload);
  addLineItemEventsHelper(lineItemsToUpdate, payload);
  return stateLineItems;
};

const createListWithNamedType = (listName = '') =>
  (state = initialState, { type, payload }) => {
    const newState = {};
    const payloadType = has(payload, 'type') ? payload.type : '';
    const isHandlingException = payloadType === 'exception'
      && ['purchaseOrders', 'phaseLineItems'].includes(listName);
    if (listName !== payloadType && !isHandlingException) return state;
    switch (type) {
      case 'REQUEST_PHASE_ITEMS_SUCCESS':
        newState.items = addBlankLineItemToPhase({ data: payload.line_items }, payloadType);
        return Object.assign({}, state, { loading: false }, newState);
      case 'CREATE_PHASE_ITEMS_SUCCESS':
      case 'CREATE_PHASE_LEVELER_ITEMS_SUCCESS':
      case 'CREATE_EXCEPTION_SUCCESS':
        newState.items = updateStateLineItemsOnCreate(state, payload, listName);
        return Object.assign({}, state, { loading: false }, newState);
      case 'DELETE_PHASE_ITEMS_SUCCESS':
        newState.items = removeStateLineItemOnDelete(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'UPDATE_PHASE_ITEMS_FAILURE':
      case 'UPDATE_PHASE_LEVELER_ITEMS_FAILURE':
      case 'CREATE_PHASE_ITEMS_FAILURE':
      case 'CREATE_PHASE_LEVELER_ITEMS_FAILURE':
      case 'DELETE_PHASE_ITEMS_FAILURE':
        newState.items = addLineItemError(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'UPDATE_PHASE_ITEMS_SUCCESS':
        newState.items = updateStateLineItemsOnUpdate(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'UPDATE_PHASE_LEVELER_ITEMS_SUCCESS:':
        newState.items = addBlankLevelerToPhase(state, payload);
        return Object.assign({}, state, { loading: false }, newState);
      case 'REQUEST_PHASE_ITEMS_REQUEST':
      case 'DELETE_PHASE_ITEMS_REQUEST':
        return {
          ...state,
          loading: true,
        };
      case 'REQUEST_PHASE_ITEMS_FAILURE':
      case 'APPROVE_LABOR_SHEET_FAILURE':
        return {
          ...state,
          errors: payload.errors || {},
          loading: false,
        };
      case 'PHASE_ITEM_EVENTS_REQUEST':
        return {
          ...state,
          loading: true,
        };
      case 'PHASE_ITEM_EVENTS_SUCCESS':
        return {
          ...state,
          items: addLineItemEvent(state, payload),
          loading: false,
        };
      case 'PHASE_ITEM_EVENTS_FAILURE':
        return {
          ...state,
          items: addLineItemError(state, payload),
          loading: false,
        };
      case 'REQUEST_PHASE_LEVELER_ITEMS_REQUEST':
        return {
          ...state,
          loading: true,
        };
      case 'REQUEST_PHASE_LEVELER_ITEMS_SUCCESS':
        newState.items = addBlankLevelerToPhase({ data: payload.levelers }, payloadType);
        return Object.assign({}, state, { loading: false }, newState);
      case 'REQUEST_PHASE_LEVELER_ITEMS_FAILURE':
      default:
        return state;
    }
  };

export default createListWithNamedType;



// WEBPACK FOOTER //
// ./client/app/reducers/phase_items.js